export const personalInfo = {
  name: 'Kenil Balar',
  headshot: '/images/Mein Foto.png',
  title: 'Software Engineer',
  experience: '4 Years',
  email: 'kenilbalar2000@gmail.com',
  phone: '+49 15563 107269',
  location: 'Mülheim an der Ruhr, Germany',
  linkedin: 'https://www.linkedin.com/in/kenilkumar-balar-1167b1213/',
  github: 'https://github.com/KenilBalar',
  dribbble: 'https://dribbble.com/kenil-balar',
  resumeEN: '/certificates/Kenilkumar_Balar_CV.pdf',
  resumeDE: '/certificates/Kenilkumar_Balar_Lebenslauf.pdf',
}

export const skills = [
    {
    category: 'Mobile Development',
    icon: '📱',
    items: [
      { name: 'Java', level: 80 },
      { name: 'Kotlin', level: 90 },
      { name: 'Jetpack Compose', level: 90 },
      { name: 'XML', level: 95 },
      { name: 'Compose Multiplatform', level: 85 },
      { name: 'Dependency Injection (Dagger2/ Hilt)', level: 85 },
      { name: 'Asynchronous Programming (Coroutines, Flow)', level: 95},
      { name: 'Reactive Programming (RxJava)', level: 80 },
      { name: 'Unit Testing (JUnit, Mockito)', level: 45 },
{ name: 'Debugging ', level: 90 },
    ],
  },
  {
    category: 'Web Development',
    icon: '💻',
    items: [
      { name: 'HTML/CSS', level: 75 },
      { name: 'JavaScript', level: 75 },
       { name: 'TypeScript', level: 70 },
      { name: 'React.js', level: 45 },
      { name: 'Node.js', level: 60 },
      { name: 'Express.js', level: 60 },
      { name: 'Spring Boot', level: 70 },
      { name: 'PostgreSQL', level: 75 },
      { name: 'REST APIs', level: 70 },
     { name: 'Postman', level: 95 },
      
    ],
  },
  {
    category: 'UI-UX & Graphic Design',
    icon: '🎨',
    items: [
      { name: 'Figma', level: 90 },
      { name: 'CorelDRAW', level: 70 },
      { name: 'Adobe XD', level: 65 },
      { name: 'Adobe Photoshop', level: 60 },
      { name: 'Adobe Premier Pro', level: 55 },
    ],
  },
  {
    category: 'DevOps & Tools',
    icon: '🚀',
    items: [
      { name: 'Docker', level: 80 },
      { name: 'GitHub Actions', level: 75 },
      { name: 'AWS', level: 65 },
      { name: 'Git/GitHub', level: 95 },
      { name: 'CI/CD', level: 75 },
    ],
  },
]

export const experiences = [
  {
    id: 1,
    role: 'Senior Android Developer',
    company: 'Hyeon Infotech',
    location: 'Remote',
    period: 'Dec 2024 – Aug 2025',
    type: 'Full-time',
    description:
      'Technical lead of a 5-member Android team working in a Scrum environment, driving quality and efficiency across multiple production applications.',
    highlights: [
      'Led a 5-member Android team as technical lead in a Scrum environment',
      'Conducted code reviews and mentored junior developers',
      'Developed modular project structures to improve team efficiency',
      'Ensured stable releases through structured testing processes',
    ],
    tech: ['Kotlin', 'Jetpack Compose', 'Android SDK', 'Scrum', 'Git', 'JUnit'],
  },
  {
    id: 2,
    role: 'Android Developer',
    company: 'Hyeon Infotech',
    location: 'Surat, India',
    period: 'Feb 2023 – Oct 2024',
    type: 'Full-time',
    description:
      'Developed and maintained 7 Android applications with a combined total of over 536,000 downloads on the Google Play Store.',
    highlights: [
      'Developed and maintained 7 Android apps with 536,000+ total downloads',
      'Migrated existing applications from Java to Kotlin',
      'Integrated REST APIs and optimised application performance',
      'Secured sensitive company data using a C++ native module',
    ],
    tech: ['Kotlin', 'Java', 'C++', 'REST APIs', 'Android SDK', 'Play Store'],
  },
  {
    id: 3,
    role: 'Android Developer',
    company: 'CoderKube Technologies',
    location: 'Surat, India',
    period: 'Jun 2021 – Feb 2023',
    type: 'Full-time',
    description:
      'Built mobile applications using Java and Kotlin, collaborating with design and QA teams in agile projects and publishing apps on the Google Play Store.',
    highlights: [
      'Developed mobile applications with Java and Kotlin',
      'Collaborated with design and QA teams in agile projects',
      'Published and managed multiple applications on the Google Play Store',
      'Participated in technical client meetings and feature planning',
    ],
    tech: ['Kotlin', 'Java', 'Android SDK', 'Google Play', 'Agile', 'Firebase'],
  },
]

export const education = [
  {
    id: 1,
    degree: 'M.Sc. Computer Engineering',
    institution: 'Universität Duisburg-Essen',
    location: 'Duisburg, Germany',
    period: 'Oct 2025 – Present',
    grade: 'Ongoing',
    description:
      "Currently pursuing a Master's degree in Computer Engineering at the University of Duisburg-Essen, Germany.",
    highlights: ['Interactive Systems', 'Scientific Visualization', 'IOT: Protocols and System Software', 'Distributed Systems', 'Cloud, Mobile & Web', 'Advanced Image Synthesis',  'Computer Graphics'],
  },
  {
    id: 2,
    degree: 'Bachelor of Computer Engineering',
    institution: 'Gujarat Technological University',
    location: 'Ahmedabad, India',
    period: 'Jul 2018 – Jun 2022',
    grade: 'Completed',
    description:
      'Strong foundation in computer science fundamentals covering data structures, algorithms, databases, OOP, computer networks, and mobile development.',
    highlights: ['Data Structures', 'Algorithms', 'DBMS', 'OOP' , 'Software Engineering', 'Mobile Application Development','Web Development','Computer Networks', 'Cybersecurity', 'Artificial Intelligence', 'Machine Learning'],
  },
]

export const projects = [
  {
    id: 1,
    title: 'FraxinusFly — B2B Business App',
    description:
      'A B2B Android application managing quotations, orders, and business workflows with PDF and XLS export functionality.',
    longDesc:
      'Enterprise-grade B2B app for business management. Features quotation and order management, dynamic PDF and XLS document export, and a clean Jetpack Compose UI.',
    tech: ['Kotlin','QR Scanner', 'Firebase', 'REST APIs', 'PDF Export', 'XLS Export', 'Room DB'],
    github: 'https://github.com/KenilBalar',
    demo: null,
    featured: false,
    category: 'Android',
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },
  {
    id: 2,
    title: 'Translator App — Real-Time Translation',
    description:
      'Real-time translation Android app integrating Google ML Kit and REST APIs with camera-based live text translation.',
    longDesc:
      'Integrates Google ML Kit for on-device text recognition with translation REST APIs. Supports camera-based real-time translation and manual text input for multiple languages.',
    tech: ['Kotlin', 'Google ML Kit', 'REST APIs', 'CameraX', 'Jetpack Compose'],
    github: 'https://github.com/KenilBalar',
    demo: null,
    featured: false,
    category: 'Android',
    gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  },
  {
    id: 3,
    title: 'Weather App',
    description:
      'A modern weather application built with Jetpack Compose and the OpenWeather API, featuring live forecasts and a beautiful UI.',
    longDesc:
      'Showcases modern Android development using Jetpack Compose, OpenWeather API, and clean MVVM architecture with Coroutines.',
    tech: ['Kotlin', 'Jetpack Compose', 'OpenWeather API', 'MVVM', 'Retrofit', 'Coroutines'],
    github: 'https://github.com/KenilBalar',
    demo: null,
    featured: false,
    category: 'Android',
    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
  },
   {
    id: 4,
    title: 'Compose Multiplatform App',
    description:
      'Cross-platform mobile application sharing business logic between Android and iOS using Kotlin Multiplatform Mobile.',
    tech: ['Jetpack Compose','Ktor', 'Google Cloud', 'SQLDelight', 'Navigation'],
    github: 'https://github.com/KenilBalar',
    demo: null,
    featured: false,
    category: 'Android & iOS',
    gradient: 'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)',
  },
  {
    id: 5,
    title: 'Portfolio Website',
    description:
      'Personal portfolio built with React, TypeScript, Node.js and MongoDB, the website you are on right now :)',
    tech: ['React', 'TypeScript', 'Node.js', 'MongoDB', 'Framer Motion', 'Docker'],
    github: 'https://github.com/KenilBalar',
    demo: null,
    featured: false,
    category: 'Full Stack',
    gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
  },
  {
    id: 6,
    title: 'Spring Boot REST API',
    description:
      'A RESTful backend API built with Spring Boot, featuring JWT authentication, PostgreSQL persistence, and Docker containerisation.',
    tech: ['Spring Boot', 'Java', 'PostgreSQL', 'JWT', 'Docker', 'JUnit'],
    github: 'https://github.com/KenilBalar',
    demo: null,
    featured: false,
    category: 'Backend',
    gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
  },
 
]

export const certificates = [

  {
    id: 1,
    title: 'Docker',
    issuer: 'Docker & LinkedIn',
    date: 'June 2025',
    localFile: 'public/certificates/Docker-Zertifikat.pdf',
    credentialId: 'd48f242220c6b92b9e4bdcb3e991dd5a0b4cdc4165c6f609230d78287e8a29f3',
    credentialUrl: 'https://www.linkedin.com/learning/certificates/d48f242220c6b92b9e4bdcb3e991dd5a0b4cdc4165c6f609230d78287e8a29f3',
    icon: '🐳',
    color: '#56c1c9ff',
  },
    {
    id: 2,
    title: 'Spring Boot',
    issuer: 'Amigoscode',
    date: 'July 2025',
    localFile: 'public/certificates/Spring Boot-Zertifikat.pdf',
    credentialId: '698d59ee-ec27-4610-bb3e-b0bf14943c56',
    credentialUrl: 'https://amigoscode.com/certificates/698d59ee-ec27-4610-bb3e-b0bf14943c56',
    icon: '🌱',
    color: '#56c1c9ff',
  }
  ,
    {
    id: 3,
    title: 'Deutsch B2 ',
    issuer: 'L.A.N.E.S',
    date: 'December 2025',
    localFile: 'public/certificates/L.A.N.E.S B2 Zertifkat.pdf',
    credentialId: '',
    credentialUrl: '',
    icon: '🇩🇪',
    color: '#56c1c9ff',
  }
]
